
import { useLanguage } from '../../../contexts/LanguageContext';

export default function Services() {
  const { t } = useLanguage();

  const services = [
    {
      icon: 'ri-smartphone-line',
      titleKey: 'services.app.title',
      descKey: 'services.app.desc'
    },
    {
      icon: 'ri-database-2-line',
      titleKey: 'services.data.title',
      descKey: 'services.data.desc'
    },
    {
      icon: 'ri-line-chart-line',
      titleKey: 'services.analytics.title',
      descKey: 'services.analytics.desc'
    },
    {
      icon: 'ri-map-pin-line',
      titleKey: 'services.gis.title',
      descKey: 'services.gis.desc'
    },
    {
      icon: 'ri-cloud-line',
      titleKey: 'services.cloud.title',
      descKey: 'services.cloud.desc'
    },
    {
      icon: 'ri-team-line',
      titleKey: 'services.training.title',
      descKey: 'services.training.desc'
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-white/5 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#ff6b4a]"></div>
            <span className="text-[#f5f1e8]/70 text-sm font-medium uppercase tracking-wider">{t('services.badge')}</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif font-bold text-white mb-4">
            {t('services.title')}
          </h2>
          <p className="text-[#f5f1e8]/70 text-lg max-w-2xl mx-auto">
            {t('services.description')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-3xl p-8 hover:transform hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl border border-white/10"
            >
              <div className="w-16 h-16 rounded-full bg-[#4a7c59]/30 flex items-center justify-center mb-6 group-hover:bg-[#4a7c59]/50 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-[#f5f1e8]`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{t(service.titleKey)}</h3>
              <p className="text-[#f5f1e8]/70 leading-relaxed">{t(service.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
